// // src/pages/treatments/OrthopaedicsPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const ORTHOPAEDICS_TREATMENT = {
//   slug: "orthopaedics",
//   name: "Orthopaedic Treatment",
//   shortName: "Orthopaedics",
//   tagline: "Move Without Pain. Live Without Limits. Expert Bone & Joint Care.",
//   heroSubtag:
//     "Advanced orthopaedic surgery at a fraction of Western costs. India's top bone and joint specialists. Outstanding functional outcomes.",
//   description:
//     "Comprehensive orthopaedic care covering joint replacement, spine surgery, sports medicine, trauma, paediatric orthopaedics and complex reconstructive surgery — supported by advanced physiotherapy, pain management and lifelong post-operative follow-up. Our multidisciplinary orthopaedic teams review every case to deliver globally benchmarked, personalised treatment plans with exceptional outcomes across all musculoskeletal conditions.",
//   heroImage: "/Orthopaedic.jpeg",
//   category: "Orthopedics",
//   badge: "Advanced Bone & Joint Care",
//   accentColor: "blue",
//   costCard: {
//     label: "Orthopaedic surgery packages from",
//     value: "₹1.5L–₹8L",
//     compare: "vs. £10,000–£40,000 in the UK",
//     stay: "Typically 7–21 days in India depending on procedure",
//     stayCompare: "vs. $20,000–$100,000 in the USA",
//   },
//   stats: [
//     { label: "Success Rate", value: "97%+", icon: Award },
//     { label: "Surgeries Performed", value: "50,000+", icon: Users },
//     { label: "Years Experience", value: "25+", icon: Shield },
//     { label: "Specialties Covered", value: "10+", icon: Clock },
//   ],
//   benefits: [
//     "Robotic-assisted joint replacement — total hip, knee and shoulder",
//     "Minimally invasive spine surgery — MISS, TLIF, ALIF and endoscopic discectomy",
//     "Arthroscopic sports medicine — ACL, meniscus, rotator cuff and labral repair",
//     "Complex trauma and fracture reconstruction — pelvis, acetabulum, long bones",
//     "Paediatric orthopaedics — clubfoot, scoliosis, DDH and limb deformity correction",
//     "Limb lengthening and deformity correction using Ilizarov and hexapod frames",
//     "Bone tumour surgery and limb salvage procedures",
//     "Platelet-rich plasma (PRP) and biologics for non-surgical joint conditions",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Assessment & Diagnosis",
//       desc: "Complete orthopaedic evaluation — weight-bearing X-rays, MRI, CT scan, deformity analysis, gait assessment and specialist consultation.",
//       duration: "2–3 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Pre-Operative Planning",
//       desc: "3D surgical planning, implant selection, cardiac and anaesthesia clearance, physiotherapy baseline assessment and patient education.",
//       duration: "1–2 Days",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Surgery",
//       desc: "Robotic-assisted, minimally invasive or conventional orthopaedic surgery by senior subspecialty orthopaedic surgeon with dedicated OT team.",
//       duration: "1–6 Hours",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Rehabilitation & Discharge",
//       desc: "Physiotherapy begins within 24 hours of surgery. Personalised home exercise programme and telemedicine follow-up protocol provided on discharge.",
//       duration: "5–21 Days",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "What orthopaedic conditions do you treat?",
//       a: "We treat the full spectrum of musculoskeletal conditions including osteoarthritis, rheumatoid arthritis, avascular necrosis, spine disc disease, scoliosis, sports injuries (ACL, meniscus, rotator cuff), fractures, bone tumours, paediatric deformities, limb length discrepancy and failed previous orthopaedic surgery requiring revision.",
//     },
//     {
//       q: "What is robotic-assisted orthopaedic surgery?",
//       a: "Robotic-assisted surgery uses a CT-based 3D model of your joint to plan the exact position, size and alignment of your implant before the operation. During surgery, the robotic arm guides the surgeon to execute cuts within 1mm of the pre-operative plan — resulting in better alignment, less bone removal, reduced blood loss and faster recovery compared to conventional surgery.",
//     },
//     {
//       q: "What is minimally invasive spine surgery (MISS)?",
//       a: "MISS uses small incisions, tubular retractors and fluoroscopic or endoscopic guidance to access the spine with minimal muscle disruption. Compared to open spine surgery, MISS results in less post-operative pain, shorter hospital stay (1–3 days vs 5–7 days), faster return to activity and significantly reduced blood loss.",
//     },
//     {
//       q: "How soon can I travel after orthopaedic surgery?",
//       a: "Travel readiness depends on the procedure. After joint replacement, most patients are cleared to fly economy class within 10–14 days with compression stockings and anticoagulation. After spine surgery, most patients fly within 7–10 days. After arthroscopic procedures, patients can often fly within 3–5 days. PaxGrow arranges supervised physiotherapy before your flight.",
//     },
//     {
//       q: "Are global implant brands available in India?",
//       a: "Yes. All major global implant brands are available — Stryker, Zimmer Biomet, DePuy Synthes, Smith+Nephew, Medtronic, NuVasive. Patients can choose implant brand and material (titanium, ceramic, cobalt-chrome) in consultation with their surgeon. Indian pricing for these same implants is 60–80% lower than in the UK or USA.",
//     },
//     {
//       q: "What is the cost of orthopaedic surgery in India vs. the UK or USA?",
//       a: "Orthopaedic surgery in India costs 70–85% less than in the UK or USA. A total knee replacement costs ₹2.5L–₹4L vs £15,000–£25,000 in the UK. Spine surgery (TLIF) costs ₹3L–₹6L vs $50,000–$100,000 in the USA. ACL reconstruction costs ₹1.5L–₹2.5L vs $20,000–$40,000 in the USA — with equivalent implants and superior surgeon experience volumes.",
//     },
//     {
//       q: "Do you offer non-surgical treatments for joint pain?",
//       a: "Yes. For early-to-moderate arthritis and sports injuries, we offer platelet-rich plasma (PRP) injections, hyaluronic acid viscosupplementation, corticosteroid injections under ultrasound guidance, physiotherapy and bracing. Our orthopaedic specialists evaluate every patient for the most appropriate treatment — surgical or non-surgical — based on imaging and clinical findings.",
//     },
//     {
//       q: "What is limb lengthening and who needs it?",
//       a: "Limb lengthening uses an external fixator (Ilizarov frame or hexapod) or internal lengthening nail to gradually lengthen a short limb — typically 1mm per day. Indications include post-traumatic limb shortening, congenital limb length discrepancy, achondroplasia and post-infection growth arrest. India's orthopaedic centres have among the highest volumes of limb lengthening surgery in Asia.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Ashok Rajgopal",
//       specialty: "Joint Replacement & Robotic Orthopaedics",
//       experience: "35 Years",
//       rating: 4.9,
//       reviews: 4200,
//       image: "https://randomuser.me/api/portraits/men/54.jpg",
//       qualifications: "MBBS, MS (Ortho), MCh, FRCS (Edinburgh)",
//       hospital: "Medanta — The Medicity, Gurgaon",
//     },
//     {
//       name: "Dr. Rajesh Malhotra",
//       specialty: "Trauma & Complex Reconstruction",
//       experience: "30 Years",
//       rating: 4.9,
//       reviews: 3500,
//       image: "https://randomuser.me/api/portraits/men/66.jpg",
//       qualifications: "MBBS, MS (Ortho), DNB, FRCS",
//       hospital: "AIIMS, New Delhi",
//     },
//     {
//       name: "Dr. Satish Rudrappa",
//       specialty: "Spine Surgery & Neurosurgery",
//       experience: "26 Years",
//       rating: 4.8,
//       reviews: 2800,
//       image: "https://randomuser.me/api/portraits/men/48.jpg",
//       qualifications: "MBBS, MCh (Neurosurgery), DNB, FISS",
//       hospital: "Manipal Hospital, Bangalore",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Daniel Kipchoge",
//       age: 52,
//       location: "Nairobi, Kenya",
//       text: "Severe disc prolapse at L4-L5 had left me with foot drop and unable to walk properly for eight months. The minimally invasive TLIF surgery at Medanta took three hours. I walked the next morning without foot drop. Flew home after nine days. The neurosurgeon explained everything in plain English and the PaxGrow coordinator was with me at every appointment. Exceptional experience.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/44.jpg",
//       treatment: "Minimally Invasive TLIF — L4-L5 Disc Prolapse with Foot Drop",
//       date: "December 2023",
//     },
//     {
//       name: "Aisha Mohammed",
//       age: 16,
//       location: "Khartoum, Sudan",
//       text: "My daughter had severe scoliosis — 68 degree Cobb angle — and was being told she needed open spinal fusion. The team at AIIMS Delhi performed posterior spinal instrumentation and fusion. Her curve was corrected to 14 degrees. She is now standing straight for the first time in her life and growing normally. We will be forever grateful.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/32.jpg",
//       treatment: "Posterior Spinal Fusion & Instrumentation — Adolescent Idiopathic Scoliosis",
//       date: "February 2024",
//     },
//     {
//       name: "Tariq Al-Mansouri",
//       age: 34,
//       location: "Doha, Qatar",
//       text: "ACL rupture during football had kept me off the pitch for a year. Two surgeons in Qatar recommended different operations and I was confused. PaxGrow arranged a video consultation with a sports medicine specialist in Chennai who confirmed the correct approach. The arthroscopic ACL reconstruction was done using my own hamstring graft. I was back playing football five months later.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/61.jpg",
//       treatment: "Arthroscopic ACL Reconstruction — Football Injury",
//       date: "March 2024",
//     },
//   ],
// };

// const ORTHOPAEDICS_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African & Gulf Patients Choose India for Orthopaedic Care",
//   whyIndiaReasons: [
//     "NABH-accredited orthopaedic centres with Mako robotic systems, O-arm intraoperative imaging, navigation and full arthroscopic sports medicine capability",
//     "Fellowship-trained orthopaedic subspecialists — joint replacement, spine, sports medicine, trauma, paediatric and tumour — performing 500–1,500 cases per year",
//     "Surgery confirmed within 5–7 days of arrival — no 12–18 month NHS waiting lists or insurance pre-authorisation delays",
//     "Apollo, AIIMS, Medanta, Fortis, Manipal, Kokilaben — globally ranked orthopaedic programmes with published outcome data and implant registries",
//   ],
//   conditionsTitle: "Orthopaedic Conditions We Facilitate Treatment For",
//   conditions: [
//     "Osteoarthritis — Hip, Knee & Shoulder",
//     "Rheumatoid Arthritis",
//     "Avascular Necrosis (AVN)",
//     "Lumbar & Cervical Disc Disease",
//     "Scoliosis & Spinal Deformity",
//     "ACL, PCL & Meniscus Injuries",
//     "Rotator Cuff Tears",
//     "Complex Fractures & Non-Union",
//     "Bone Tumours & Limb Salvage",
//     "Paediatric Orthopaedic Deformities",
//     "Limb Length Discrepancy",
//     "Failed Previous Orthopaedic Surgery",
//   ],
//   stayValue:
//     "Arthroscopy: 5–7 days · Joint Replacement: 10–14 days · Spine Surgery: 7–14 days · Complex Reconstruction: 14–21 days. PaxGrow arranges supervised physiotherapy and accommodation before you fly home.",
//   costTitle: "Why India for Orthopaedic Surgery?",
//   costRows: [
//     {
//       procedure: "Total Knee / Hip Replacement",
//       india: "₹2.5L–₹5L",
//       africa: "$8,000–$15,000",
//       ukusa: "$30,000–$60,000",
//     },
//     {
//       procedure: "Spine Surgery (TLIF / ALIF)",
//       india: "₹3L–₹6L",
//       africa: "$10,000–$20,000",
//       ukusa: "$50,000–$100,000",
//     },
//     {
//       procedure: "ACL Reconstruction (Arthroscopic)",
//       india: "₹1.5L–₹2.5L",
//       africa: "$4,000–$8,000",
//       ukusa: "$20,000–$40,000",
//     },
//     {
//       procedure: "Scoliosis Correction Surgery",
//       india: "₹5L–₹9L",
//       africa: "Largely unavailable",
//       ukusa: "$80,000–$150,000",
//     },
//     {
//       procedure: "Limb Lengthening & Deformity Correction",
//       india: "₹3L–₹7L",
//       africa: "Largely unavailable",
//       ukusa: "$50,000–$120,000",
//     },
//   ],
// };

// const OrthopaedicsPage = () => {
//   return (
//     <TreatmentTemplate
//       treatment={ORTHOPAEDICS_TREATMENT}
//       paxgrowData={ORTHOPAEDICS_PAXGROW}
//     />
//   );
// };

// export default OrthopaedicsPage;

// src/pages/treatments/OrthopaedicsPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

const ORTHOPAEDICS_TREATMENT = {
  slug: "orthopaedics",
  name: "Orthopaedic Treatment",
  shortName: "Orthopaedics",
  tagline: "Move Without Pain. Live Without Limits. Expert Bone & Joint Care.",
  heroSubtag:
    "Advanced orthopaedic surgery at a fraction of Western costs. India's top bone and joint specialists. Outstanding functional outcomes.",
  description:
    "Comprehensive orthopaedic care covering joint replacement, spine surgery, sports medicine, trauma, paediatric orthopaedics and complex reconstructive surgery — supported by advanced physiotherapy, pain management and lifelong post-operative follow-up. Our multidisciplinary orthopaedic teams review every case to deliver globally benchmarked, personalised treatment plans with exceptional outcomes across all musculoskeletal conditions.",
  heroImage: "/Orthopaedic.jpeg",
  category: "Orthopedics",
  badge: "Advanced Bone & Joint Care",
  accentColor: "blue",
  costCard: {
    label: "Orthopaedic surgery packages from",
    value: "$1,800–$9,600",
    compare: "vs. $12,000–$48,000 in the UK",
    stay: "Typically 7–21 days in India depending on procedure",
    stayCompare: "vs. $20,000–$100,000 in the USA",
  },
  stats: [
    { label: "Success Rate", value: "97%+", icon: Award },
    { label: "Surgeries Performed", value: "50,000+", icon: Users },
    { label: "Years Experience", value: "25+", icon: Shield },
    { label: "Specialties Covered", value: "10+", icon: Clock },
  ],
  benefits: [
    "Robotic-assisted joint replacement — total hip, knee and shoulder",
    "Minimally invasive spine surgery — MISS, TLIF, ALIF and endoscopic discectomy",
    "Arthroscopic sports medicine — ACL, meniscus, rotator cuff and labral repair",
    "Complex trauma and fracture reconstruction — pelvis, acetabulum, long bones",
    "Paediatric orthopaedics — clubfoot, scoliosis, DDH and limb deformity correction",
    "Limb lengthening and deformity correction using Ilizarov and hexapod frames",
    "Bone tumour surgery and limb salvage procedures",
    "Platelet-rich plasma (PRP) and biologics for non-surgical joint conditions",
  ],
  procedure: [
    {
      step: "01",
      title: "Assessment & Diagnosis",
      desc: "Complete orthopaedic evaluation — weight-bearing X-rays, MRI, CT scan, deformity analysis, gait assessment and specialist consultation.",
      duration: "2–3 Days",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Pre-Operative Planning",
      desc: "3D surgical planning, implant selection, cardiac and anaesthesia clearance, physiotherapy baseline assessment and patient education.",
      duration: "1–2 Days",
      icon: Activity,
    },
    {
      step: "03",
      title: "Surgery",
      desc: "Robotic-assisted, minimally invasive or conventional orthopaedic surgery by senior subspecialty orthopaedic surgeon with dedicated OT team.",
      duration: "1–6 Hours",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Rehabilitation & Discharge",
      desc: "Physiotherapy begins within 24 hours of surgery. Personalised home exercise programme and telemedicine follow-up protocol provided on discharge.",
      duration: "5–21 Days",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "What orthopaedic conditions do you treat?",
      a: "We treat the full spectrum of musculoskeletal conditions including osteoarthritis, rheumatoid arthritis, avascular necrosis, spine disc disease, scoliosis, sports injuries (ACL, meniscus, rotator cuff), fractures, bone tumours, paediatric deformities, limb length discrepancy and failed previous orthopaedic surgery requiring revision.",
    },
    {
      q: "What is robotic-assisted orthopaedic surgery?",
      a: "Robotic-assisted surgery uses a CT-based 3D model of your joint to plan the exact position, size and alignment of your implant before the operation. During surgery, the robotic arm guides the surgeon to execute cuts within 1mm of the pre-operative plan — resulting in better alignment, less bone removal, reduced blood loss and faster recovery compared to conventional surgery.",
    },
    {
      q: "What is minimally invasive spine surgery (MISS)?",
      a: "MISS uses small incisions, tubular retractors and fluoroscopic or endoscopic guidance to access the spine with minimal muscle disruption. Compared to open spine surgery, MISS results in less post-operative pain, shorter hospital stay (1–3 days vs 5–7 days), faster return to activity and significantly reduced blood loss.",
    },
    {
      q: "How soon can I travel after orthopaedic surgery?",
      a: "Travel readiness depends on the procedure. After joint replacement, most patients are cleared to fly economy class within 10–14 days with compression stockings and anticoagulation. After spine surgery, most patients fly within 7–10 days. After arthroscopic procedures, patients can often fly within 3–5 days. PaxGrow arranges supervised physiotherapy before your flight.",
    },
    {
      q: "Are global implant brands available in India?",
      a: "Yes. All major global implant brands are available — Stryker, Zimmer Biomet, DePuy Synthes, Smith+Nephew, Medtronic, NuVasive. Patients can choose implant brand and material (titanium, ceramic, cobalt-chrome) in consultation with their surgeon. Indian pricing for these same implants is 60–80% lower than in the UK or USA.",
    },
    {
      q: "What is the cost of orthopaedic surgery in India vs. the UK or USA?",
      a: "Orthopaedic surgery in India costs 70–85% less than in the UK or USA. A total knee replacement costs $3,000–$4,800 vs $18,000–$30,000 in the UK. Spine surgery (TLIF) costs $3,600–$7,200 vs $50,000–$100,000 in the USA. ACL reconstruction costs $1,800–$3,000 vs $20,000–$40,000 in the USA — with equivalent implants and superior surgeon experience volumes.",
    },
    {
      q: "Do you offer non-surgical treatments for joint pain?",
      a: "Yes. For early-to-moderate arthritis and sports injuries, we offer platelet-rich plasma (PRP) injections, hyaluronic acid viscosupplementation, corticosteroid injections under ultrasound guidance, physiotherapy and bracing. Our orthopaedic specialists evaluate every patient for the most appropriate treatment — surgical or non-surgical — based on imaging and clinical findings.",
    },
    {
      q: "What is limb lengthening and who needs it?",
      a: "Limb lengthening uses an external fixator (Ilizarov frame or hexapod) or internal lengthening nail to gradually lengthen a short limb — typically 1mm per day. Indications include post-traumatic limb shortening, congenital limb length discrepancy, achondroplasia and post-infection growth arrest. India's orthopaedic centres have among the highest volumes of limb lengthening surgery in Asia.",
    },
  ],
  doctors: [
    {
      name: "Dr. Ashok Rajgopal",
      specialty: "Joint Replacement & Robotic Orthopaedics",
      experience: "35 Years",
      rating: 4.9,
      reviews: 4200,
      image: "https://randomuser.me/api/portraits/men/54.jpg",
      qualifications: "MBBS, MS (Ortho), MCh, FRCS (Edinburgh)",
      hospital: "Medanta — The Medicity, Gurgaon",
    },
    {
      name: "Dr. Rajesh Malhotra",
      specialty: "Trauma & Complex Reconstruction",
      experience: "30 Years",
      rating: 4.9,
      reviews: 3500,
      image: "https://randomuser.me/api/portraits/men/66.jpg",
      qualifications: "MBBS, MS (Ortho), DNB, FRCS",
      hospital: "AIIMS, New Delhi",
    },
    {
      name: "Dr. Satish Rudrappa",
      specialty: "Spine Surgery & Neurosurgery",
      experience: "26 Years",
      rating: 4.8,
      reviews: 2800,
      image: "https://randomuser.me/api/portraits/men/48.jpg",
      qualifications: "MBBS, MCh (Neurosurgery), DNB, FISS",
      hospital: "Manipal Hospital, Bangalore",
    },
  ],
  testimonials: [
    {
      name: "Daniel Kipchoge",
      age: 52,
      location: "Nairobi, Kenya",
      text: "Severe disc prolapse at L4-L5 had left me with foot drop and unable to walk properly for eight months. The minimally invasive TLIF surgery at Medanta took three hours. I walked the next morning without foot drop. Flew home after nine days. The neurosurgeon explained everything in plain English and the PaxGrow coordinator was with me at every appointment. Exceptional experience.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/44.jpg",
      treatment: "Minimally Invasive TLIF — L4-L5 Disc Prolapse with Foot Drop",
      date: "December 2023",
    },
    {
      name: "Aisha Mohammed",
      age: 16,
      location: "Khartoum, Sudan",
      text: "My daughter had severe scoliosis — 68 degree Cobb angle — and was being told she needed open spinal fusion. The team at AIIMS Delhi performed posterior spinal instrumentation and fusion. Her curve was corrected to 14 degrees. She is now standing straight for the first time in her life and growing normally. We will be forever grateful.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/32.jpg",
      treatment: "Posterior Spinal Fusion & Instrumentation — Adolescent Idiopathic Scoliosis",
      date: "February 2024",
    },
    {
      name: "Tariq Al-Mansouri",
      age: 34,
      location: "Doha, Qatar",
      text: "ACL rupture during football had kept me off the pitch for a year. Two surgeons in Qatar recommended different operations and I was confused. PaxGrow arranged a video consultation with a sports medicine specialist in Chennai who confirmed the correct approach. The arthroscopic ACL reconstruction was done using my own hamstring graft. I was back playing football five months later.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/61.jpg",
      treatment: "Arthroscopic ACL Reconstruction — Football Injury",
      date: "March 2024",
    },
  ],
};

const ORTHOPAEDICS_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African & Gulf Patients Choose India for Orthopaedic Care",
  whyIndiaReasons: [
    "NABH-accredited orthopaedic centres with Mako robotic systems, O-arm intraoperative imaging, navigation and full arthroscopic sports medicine capability",
    "Fellowship-trained orthopaedic subspecialists — joint replacement, spine, sports medicine, trauma, paediatric and tumour — performing 500–1,500 cases per year",
    "Surgery confirmed within 5–7 days of arrival — no 12–18 month NHS waiting lists or insurance pre-authorisation delays",
    "Apollo, AIIMS, Medanta, Fortis, Manipal, Kokilaben — globally ranked orthopaedic programmes with published outcome data and implant registries",
  ],
  conditionsTitle: "Orthopaedic Conditions We Facilitate Treatment For",
  conditions: [
    "Osteoarthritis — Hip, Knee & Shoulder",
    "Rheumatoid Arthritis",
    "Avascular Necrosis (AVN)",
    "Lumbar & Cervical Disc Disease",
    "Scoliosis & Spinal Deformity",
    "ACL, PCL & Meniscus Injuries",
    "Rotator Cuff Tears",
    "Complex Fractures & Non-Union",
    "Bone Tumours & Limb Salvage",
    "Paediatric Orthopaedic Deformities",
    "Limb Length Discrepancy",
    "Failed Previous Orthopaedic Surgery",
  ],
  stayValue:
    "Arthroscopy: 5–7 days · Joint Replacement: 10–14 days · Spine Surgery: 7–14 days · Complex Reconstruction: 14–21 days. PaxGrow arranges supervised physiotherapy and accommodation before you fly home.",
  costTitle: "Why India for Orthopaedic Surgery?",
  costRows: [
    {
      procedure: "Total Knee / Hip Replacement",
      india: "$3,000–$6,000",
      africa: "$8,000–$15,000",
      ukusa: "$30,000–$60,000",
    },
    {
      procedure: "Spine Surgery (TLIF / ALIF)",
      india: "$3,600–$7,200",
      africa: "$10,000–$20,000",
      ukusa: "$50,000–$100,000",
    },
    {
      procedure: "ACL Reconstruction (Arthroscopic)",
      india: "$1,800–$3,000",
      africa: "$4,000–$8,000",
      ukusa: "$20,000–$40,000",
    },
    {
      procedure: "Scoliosis Correction Surgery",
      india: "$6,000–$11,000",
      africa: "Largely unavailable",
      ukusa: "$80,000–$150,000",
    },
    {
      procedure: "Limb Lengthening & Deformity Correction",
      india: "$3,600–$8,500",
      africa: "Largely unavailable",
      ukusa: "$50,000–$120,000",
    },
  ],
};

const OrthopaedicsPage = () => {
  return (
    <TreatmentTemplate
      treatment={ORTHOPAEDICS_TREATMENT}
      paxgrowData={ORTHOPAEDICS_PAXGROW}
    />
  );
};

export default OrthopaedicsPage;